export default "__VITE_ASSET__C061jT60__"